<template>
<v-app class="ma-0 pa-0">
  <div id="app">
    <ebm-header/>
    <div class="image_upload">
      <div class="image_upload_row">
        <div class="column1">
          <p id="text1">光碟入手機</p>
          <p id="text2">自助上傳工具</p>
          <p id="text3">適用項目</p>
          <div class="image_upload_div">
            <div class="image_upload_case" align="center">
              <img src="@/assets/medical_cd/putdisk.png" class="circle_img">
              <p class="b-36">影像光碟</p>
            </div>
            <div class="image_upload_case pl-58" align="center">
              <v-dialog
                v-model="yt_dialog"
                persistent
                max-width="880px">
                <template v-slot:activator="{ on, attrs }">
                  <span class="dot" style="cursor: pointer;" v-bind="attrs" v-on="on">
                  <div class="inline-block">
                      <img src="@/assets/medical_cd/myhealthbank.png" class="circle_img">
                  </div>
                  </span>
                </template>
                <v-card class="pa-4">
                  <v-row class="d-flex justify-end pa-3 mb-1">
                    <v-btn icon 
                    color="error"
                    large
                    @click="close_yt_dialog"><v-icon>mdi-close</v-icon>
                </v-btn>
                </v-row>
                <div class="center">
                <video controls :width="yt_width" :height="yt_height" autoplay @ended="yt_dialog=false" @playing="updatePaused" id="videoEl">
                  <source src="@/assets/medical_cd/upload_video.mp4"
                          type="video/mp4">
                  Sorry, your browser doesn't support embedded videos.
                </video>
                </div>
                 </v-card>
              </v-dialog>
              <p class="b-36">健康存摺影像</p>
            </div>
            <div class="image_upload_case pl-58" align="center">
                <v-dialog
                v-model="dialog"
                persistent
                max-width="720px">
                <template v-slot:activator="{ on, attrs }">
                  <span class="dot" style="cursor: pointer;" v-bind="attrs" v-on="on">
                  <div class="inline-block">
                      <img src="@/assets/medical_cd/Upload.png" class="upload_img">
                  </div>
                  </span>
                </template>
                <v-card class="pa-4">
                  <v-row class="d-flex justify-end pa-3">
                      <v-btn icon 
                      color="error"
                      large
                      @click="closeDialog"><v-icon>mdi-close</v-icon>
                  </v-btn>
                  </v-row>
                  <v-form v-on:submit.prevent="submit">
                  <v-card-title align="center">
                    <span v-if="!uploadSucess && !whileUploading" class="text-h5 ">請選取含有影像檔之目錄</span>
                    <span v-if="whileUploading && hospitalName" class="text-h5 ">影像將傳送至{{hospitalName}}醫院，請稍後… 需同時向該院所申請外院片光碟影像轉入，影像方能送達該醫院系統中</span>
                    <span v-if="uploadSucess" class="text-h5"> 請開啟手機中之FHR APP，掃描QR code，將影像檔載入手機</span>
                  </v-card-title>
                  <v-card-text>
                      <v-row v-if="!uploadSucess && !whileUploading">
                        <v-col cols="12">
                          <v-file-input
                        type="file"
                        multiple
                        webkitdirectory directory
                        v-model="dropboxForm.files"
                        counter
                        ref="file"
                    ></v-file-input>
                        <!-- <input ref="file" class="fileUploaderClass" type='file' name="file" webkitdirectory @change.stop="changesData"/> -->
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            value="Select"
                            v-model="dropboxForm.password"
                            label="請輸入身分證末4碼*"
                            type="password"
                            counter="4"
                            required
                            :rules="rules"
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12">
                        <v-text-field
                          v-model="dropboxForm.email"
                          :rules="emailRules"
                          label="電子郵件"
                        ></v-text-field>
                        </v-col> -->
                      </v-row>
                      <div v-if="whileUploading" class="whileUpload">
                        <v-progress-linear v-model="progress" style="margin-top:14px; margin-bottom:24px;"></v-progress-linear> 
                        <p v-if="!compressing" style="font-size:20px;">檔案上傳中… {{this.progress}}%完成</p>
                        <p v-else style="font-size:20px;" >檔案壓縮中，請稍後…</p>
                      </div>
                      <qrcode v-show="qrCodeUrl" v-model="qrCodeUrl" ></qrcode>
                      <p v-show="uploadAge" style="font-size:20px;">
                          Name: {{uploadName}}
                      </p>
                      <p v-show="uploadAge" style="font-size:20px;">
                          Age: {{uploadAge}}
                      </p>
                      <p v-show="uploadSex" style="font-size:20px;">
                          Sex: {{uploadSex}}
                      </p>
                      <p v-if="hospitalDataSending" style="font-size:20px;" >影像傳送醫院中</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="!uploadSucess && !whileUploading"
                      v-show="this.dropboxForm.files!='' &&
                      this.dropboxForm.password.length==4"
                      color="blue"
                      text large
                      @click="submit"
                      >
                      <span class="text-h5 ">上傳</span>
                    </v-btn>
                  </v-card-actions>
                  </v-form>
                </v-card>
                </v-dialog>
              <p class="b-36">點此上傳</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body_image_upload" id="scrollhere">
      <div class="center">
        <p class="body_t b-36">操作四步驟 影像帶著走</p>
        <div @click="$vuetify.goTo('#scrollhere')">
        <img src="@/assets/medical_cd/downarrow.png" class="scroll"></div>
      </div>
      <div class="mt-74">
        <div class="image_upload_row">
        <div class="column3 pl-416">
          <div class="button mt-20 inline-block v-top">
            <p class="button_content">步驟一</p>
          </div>
          <div class="step_one inline-block">
            <p class="bold_title pt-26 pl-20">準備好光碟 & 影像</p>
            <p class="pt-24 indi pl-20 n-20">光碟 : 直接放入電腦光碟機 </p>
            <p class="indi pl-20 n-20">健康存摺: 參照影片說明取得影像檔</p>
            
            <a :href="`https://myhealthbank.nhi.gov.tw/IHKE0002/IHKE0002S01.aspx`" target=”_blank” style="text-decoration:none;"><p class="pt-4 bluefont pl-20 n-20">健康存摺請按此</p></a>
            <!-- <a :href="`${publicPath}healthbank.pdf`" style="text-decoration:none;" download="healthbank"><p class="pt-4 bluefont pl-20 n-20">健康存摺請按此</p></a> -->
            <!-- <p class="pt-4 bluefont pl-20 n-20" style="cursor:pointer" @click="yt_dialog =true">健康存摺請按此</p> -->
            <p class="pt-96 greyfont pl-20 n-18">** 注意檔案格式僅限標準DICOM 格式 .DCM</p>
          </div>
        </div>
        <div class="column4">
          <img src="@/assets/medical_cd/cd_man.jpg" class="cdman_image">
        </div>
        </div>
        <div class="image_upload_row">
        <div class="column3 mt-128 pl-416">
          <div class="button mt-20 inline-block v-top">
            <p class="button_content">步驟二</p>
          </div>
          <div class="step_one inline-block">
            <p class="bold_title pt-26 pl-20">上傳檔案</p>
            <p class="pt-24 greyfont pl-20 n-20">點選<span class="indi">「點此上傳」，</span>選取影像檔案</p>
          </div>
        </div>
        <div class="column-4"></div>
        </div>
        <div class="upload_function v-mid" @click="dialog=true" style="cursor:pointer;">
          <img src="@/assets/medical_cd/Upload_black.png" height="60px" width="100px" class="inline-block pt-30">
          <p class="inline-block image_title pt-43" style="color:#2A2F35; font-size:20px;">點此上傳</p>
        </div>
        <div class=" mt-128 mb-107 pl-416">
          <div class="button mt-20 inline-block v-top">
            <p class="button_content">步驟三</p>
          </div>
          <div class="step_one inline-block">
            <p class="bold_title pt-26 pl-20">產生QR Code</p>
            <p class="pt-24 greyfont pl-20 n-20">確認網路連線正常，開始上傳影像</p>
            <p class=" greyfont pl-20 n-20">上傳完成後, 自動產生 QR Code</p>
          </div>
          <div class="inline-block ml-155">
            <img src="@/assets/thirdqr.png" class="thirdqr">
          </div>
        </div>
        <div class="image_upload_row">
        <div class="column3 pl-334">
          <img src="@/assets/medical_cd/nodisk.png" class="nodisk_image">
          <!-- <img src="@/assets/line_ebm_logo.png" height="123px" width="122px" style=""> -->
        </div>
        <div class="column4 pt-100">
          <div class="button mt-20 inline-block v-top">
            <p class="button_content">步驟四</p>
          </div>
          <div class="step_one inline-block">
            <p class="bold_title pt-26 pll-20">轉入手機</p>
            <p class="pt-24 greyfont pll-20 n-20">開啟手機中之FHR APP，點選”掃描下載”。</p>
            <p class="greyfont pll-20 n-20">讀取QR Code將影像傳入手機</p>
            <div class="inline-block ">
            <p class="pt-86 greyfont pll-20 n-18">初次使用FHR者，請打開手機，</p>
            <p class="greyfont pll-20 n-18">掃描右邊QR Code進行安裝</p>
            </div>
            <div class="inline-block pll-20">
              <img src="@/assets/fhr_qr.png" class="qr_image">
            </div>
          </div>
        </div>
        </div>
        </div>
    </div>
    <contact-form/>
    <v-snackbar
      v-model="selectedPrompt"
      top
      color="blue"
      style="margin-top:150px;"
      >
      <p style="font-size:20px;">需同時向該院所申請外院片光碟影像轉入，影像方能送達該醫院系統中</p>
    </v-snackbar>
    <ebm-footer/>
  </div>
</v-app>
</template>
<script>
import ContactForm from './ContactForm.vue'
import EbmFooter from './EbmFooter.vue'
import EbmHeader from './EbmHeader.vue'
import qrcode from 'tui-vue-qrcode'
import axios from 'axios'
export default {
  components: { 
    EbmHeader,
    ContactForm,
    EbmFooter ,
    qrcode
    },
    metaInfo() {
        return { 
            title: "FHR",
            meta: [
                { name: 'description', content:  'A Viewer Ready DICOM Device.'},
            ]
        }
    },
    data(){
        return{
          publicPath: process.env.BASE_URL,
          hospitalLocName:'',
          hospitalNames:[],
          hospitalLocations:[],
          hospitalRes:[],
          compressing:false,
          uploadSucess:false,
          whileUploading:false,
          rules: [v => v.length <= 4 || '4 digit passcode'],
          progress:0,
          qrCodeUrl: "",
          uploadAge:'',
            uploadName:'',
            uploadSex:'',
          tempFile:null,
          dropboxForm:{
            files:null,
            password:''
          },
          hospitalSelected:false,
          selectedPrompt:false,
          dialog:false,
          yt_dialog:false,
          videoEl:null,
          hospitalName:'',
          hospitalLocation:'',
          hospitalDialog:false,
          hospitalDataSending: false,
          videoId:'VTt5LWkl9VU',
          emailRules: [
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
          ],
        }
    },
    computed: {
      yt_width() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 300
          case 'sm': return 560
          case 'md': return 820
          case 'lg': return 820
          case 'xl': return 820
          default : return 640
        }
      },
      yt_height() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 200
          case 'sm': return 360
          case 'md': return 460
          case 'lg': return 460
          case 'xl': return 460
          default : return 360
        }
      }
    },
    async created(){
      try {
            const res = await axios.get('https://fhrweb.ebmtech.com/net/api/Hlists')
            let response = res.data;
            this.hospitalRes =response
            this.hospitalLocations = response.map(a => a.location);
            //getting value of location only (value before comma)
        } 
        catch (err) {
              console.log(err);
        }
    },
    methods:{
    onLocationClicked(){
      this.hospitalName=''
      this.hospitalNames=[]
      this.hospitalRes.filter(obj => {
      if(obj.location===this.hospitalLocation)
      {
        this.hospitalNames.push(obj.hospitalName)
      }
    });
    },
    // addCustomerNumber(){
    //   if(this.hospitalName){
    //     let result = this.hospitalRes.filter(obj => {
    //       return obj.hospitalName === this.hospitalName
    //     })
    //   this.dropboxForm.customerNo = result[0].customerNo
    //   console.log(this.dropboxForm);
    //   }
    // },
    saveHos(){
      if(this.hospitalName && this.hospitalLocation){
        this.selectedPrompt = true
        this.hospitalSelected =true
        this.hospitalLocName = this.hospitalLocation +'.'+ this.hospitalName
      }
      this.hospitalDialog =false
    },
    cancelHos(){
      this.hospitalDialog =false
      this.hospitalLocName= ''
      this.hospitalName =''
      this.hospitalLocation =''
    },
    clearForm(){
        this.dropboxForm.files = null
        this.dropboxForm.password = ''
        // this.dropboxForm.email=''
        this.qrCodeUrl= ''
        this.uploadAge=''
        this.uploadName=''
        this.uploadSex =''
        this.uploadSucess = false
        this.progress = 0
        this.hospitalName =''
        this.hospitalLocation =''
        this.hospitalLocName=''
        this.hospitalSelected = false
        this.hospitalDataSending = false
    },
    closeDialog(){
        this.clearForm();
        this.dialog = false;
    },
    close_yt_dialog(){
      this.videoEl.pause();
      this.yt_dialog=false;
    },
    updatePaused(event) {
      this.videoEl = event.target;
      // this.paused = event.target.paused;
    },
    changesData () {
    console.log(this.$refs.file.files)
    this.dropboxForm.files = this.$refs.file.files  // 获取filelist
    },
    async submit(){
        const config = {
                headers: {"content-type": "multipart/form-data"},
                onUploadProgress: (progressEvent) => {
                  var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                  this.progress = percentCompleted;
                  if(this.progress == 100)
                  {
                    this.compressing =true
                  }
                }
            };
        console.log(this.dropboxForm);
        let formData = new FormData();
        for (let i = 0; i < this.dropboxForm.files.length; i++) {  // 每个file append到formdata里
        formData.append('files', this.dropboxForm.files[i])
        }
        formData.append("password", this.dropboxForm.password)
        // formData.append("customerNo", this.dropboxForm.customerNo)
        try {
            this.whileUploading =true
            const res = await axios.post('UploadFile',formData, config)
            console.log('files uploaded!', res);
            if(this.hospitalSelected)
            {
            //send request to new api for data transfer if hospital is selected
            this.hospitalDataSending = true
            //axios req
            this.hospitalDataSending =false
            }
            this.uploadSucess = true,
            this.whileUploading =false,
            this.compressing =false,
            this.qrCodeUrl= res.data.qrcode;
            this.uploadSex = res.data.pT_SEX;
            // masking the name
            let altName = res.data.pT_NAME;
            if (altName.match(/^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/)) {
            //....English
                altName = altName.replaceAll('^',' ');
                var regex =/\b(\w{2})\w+(\w)\b/g;
                this.uploadName = altName.replace(regex, '$1**$2')
            } else if (altName.match(/[\u3400-\u9FBF]/)) {
                //....Chinese
                let space = altName.split(" ").length - 1
                let first = altName.charAt(0);
                let last = altName.charAt(altName.length - 1);
                if(space == 0)
                this.uploadName = first+'***'+last
                if(space == 1)
                this.uploadName = first+'** **'+last
                if(space == 2)
                this.uploadName = first+'** ** **'+last
                if(space == 3)
                this.uploadName = first+'** ** ** **'+last
            } else {
                console.log("chinese char other");
                altName = altName.replaceAll('^',' ');
                this.uploadName = altName.replace(regex, '$1**$2')
            }
            // getting age from birthday
            this.uploadAge = this.calculateAge(res.data.pT_AGE)
            
            } 
        catch (err) {
              this.whileUploading =false
              if(err.response.status == '413')
              {
                alert("error")
                return;
              }
              if(err.response.status == undefined){
                alert("Server inactive")
                return;
              }
              console.log(err.response);
              alert("Image upload failed. Please try again.")
        } 
    },
    calculateAge(birthday) { 
        let year = Number(birthday.substr(0, 4));
        var month = Number(birthday.substr(4, 2)) - 1;
        var day = Number(birthday.substr(6, 2));
        var today = new Date();
        var age = today.getFullYear() - year;
        if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
        age--;
        }
        return age
    }
    }
}
</script>
<style scoped>
.v-label {
    font-size: 22px !important;
  }
.pll-20{
  padding-left: 20px;
}
.thirdqr{
  height:157px;
   width:358px;
}
.qr_image{
  height: 8rem;
}
.v-text-field {
    margin-top: 14px;
}
.nodisk_image{
  height:400px; width:523px;
}
.upload_img{
  width:100px; 
  height:65px; 
  margin-top: 79px;
}
.circle_img{
  height:225px;
   width:auto;
}
.pt-100{
  padding-top:100px ;
}
.cdman_image{
  height:312px ;
  width:536px;
}
.dot {
  height: 225px;
  width: 225px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
}
.whileUpload{
  width:100%;
  padding-top:20px;
}
.v-card__text{
  text-align: center;
}
.ml-155{
  margin-left: 155px;
}
canvas{
  height: 460px;
  width: 460px;
}
.center{
  text-align: center;
}
p{
  margin-bottom: 0rem !important;
}
.pl-23{
  padding-left: 23px;
}
.pt-53{
  margin-top: 53px;
}
.v-mid > * {
  vertical-align: middle;
}
.pt-30{
  margin-top: 30px;
}
.pt-43{
  padding-top: 43px;
}
.button:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
.pl-334{
  padding-left: 334px;
}
.upload_function{
  margin: auto;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  width: 1088px;
  height: 120px;
  margin-top: 32px;
  text-align: center;
}
.mb-107{
  margin-bottom: 107px;
}
.mt-128{
  margin-top: 128px;
}
.n-18{
  font-size: 18px;
}
.n-20{
  font-size: 20px;
}
.bold_title{
  font-size: 28px;
  font-weight: bold;
}
.v-top{
  vertical-align: top;
}
.mt-20{
  margin-top: 16px;
}
.greyfont{
  color: #707070;
}
.bluefont{
  /* text-decoration: underline; */
  color:#00BEFF;
}
.indi{
  color:#012E81;
}
.pt-86{
  padding-top: 86px;
}
.pl-20{
  padding-left: 20px;
}
.pt-26{
  padding-top: 26px;
}
.pt-24{
  padding-top: 24px;
}
.pt-16{
  padding-top: 16px;
}
.pt-253{
  padding-top: 253px;
}
.button_content{
  color: #FFFFFF;
  font-size: 28px;
  font-weight: bold;
  padding-left: 27px;
  padding-top: 9px;
}
.button > * {
  vertical-align: top;
}
.button{
  background: #00BEFF 0% 0% no-repeat padding-box;
  border-radius: 29px;
  width: 138px;
  height: 58px;
  /* margin-left: 416px; */
}
.ml-416{
  margin-left: 416px;
}
.pl-416{
  padding-left: 416px;
}
.b-28{
  font-weight: bold;
  font-style: 28px;
}
.mt-74{
  margin-top: 74px;
}
.scroll{
  width: 41px;
  height: 28px;
  /* border: 3px solid #707070; */
  margin-top: 29px;
}
.center{
  text-align: center;
}
.body_t{
  margin-top: 44px;
}
.image1{
  padding-top: 210px;
  padding-left: 288px;
}
.image1 > * {
  vertical-align: middle;
}
.image_title{
  color: #012E81;
  font-size: 28px;
  font-weight: bold;
  padding-left: 28px;
}
.inline-block{
  display: inline-block;
}
.image_upload_hero{
  background: #FFFFFF 0% 0% no-repeat padding-box;
  width: 812px;
  height: 464px;
  margin-top: 190px;
}
.b-36{
  font-size: 36px;
  font-weight: bold;
  padding-top: 22px;
}
.pl-58{
  padding-left: 168px;
}
.image_upload_case{
  display: inline-block;
}
.image_upload_div{
  padding-top: 20px;
}
#text3{
  padding-top: 20px;
  color: #2A2F35;
  font-size: 28px;
}
#text2{
  color: #012E81;
  font-size: 36px;
  font-weight: bold;
}
#text1{
  color: #012E81;
  font-size: 60px;
  font-weight: bold;
}
/* Create two equal columns that floats next to each other */
.column1 {
  padding-top: 159px;
  padding-left: 266px;
  float: left;
  /* width: 50%; */
}
.column2 {
  padding-top: 0px;
  padding-left: 0px;
  float: left;
  width: 50%;
}
.column3 {
  /* padding-top: 159px;
  padding-left: 266px; */
  float: left;
  width: 50%;
}
.column4 {
  padding-left: 0px;
  float: left;
  width: 50%;
}
/* Clear floats after the columns */
.image_upload_row:after {
  content: "";
  display: table;
  clear: both;
}
.body_im_up_content{
  width: 1088px;
  height: 1962px;
  margin: auto;
  background-color: antiquewhite;
}
.body_image_upload{
  width: 100%;
  height: 1962px;
}
.image_upload{
  width: 100%;
  height: 805px;
  background: #E7F3F5 0% 0% no-repeat padding-box;
}
@media (max-width: 1870px){
  .pl-416{
  padding-left: 286px;
}
}
@media (max-width: 1622px) {
  .cdman_image{
      height: 296px;
    width: 506px;
}
  /* Rules for laptops, small desktop screens, and smaller viewports */
  .body_image_upload{
  width: 100%;
  height: 1800px;
}
.pl-416{
  padding-left: 180px;
}
.pt-96{
  padding-top: 56px;
}
.ml-155{
  margin-left: 55px;
}
.pl-334{
  padding-left: 234px;
}
.upload_function{
  margin: auto;
  background: #F8F8F8 0% 0% no-repeat padding-box;
  width: 60%;
  height: 120px;
  margin-top: 32px;
  text-align: center;
}
}
@media (max-width: 1398px) {
  /* Rules for tablets and smaller viewports */
  .column1 {
  padding-top: 159px;
  padding-left: 166px;
  float: left;
  /* width: 50%; */
}
.body_image_upload{
  width: 100%;
  height: 1900px;
}
.pl-58{
  padding-left: 118px;
}
}
@media (max-width: 1080px) {
  /* Rules for tablets and smaller viewports */
  .column1 {
  padding-top: 159px;
  padding-left: 86px;
  float: left;
  /* width: 50%; */
}
.body_image_upload{
  width: 100%;
  height: 1900px;
}
.pl-58{
  padding-left: 98px;
}
.pl-416{
  padding-left: 90px;
}
.pl-334{
  padding-left: 82px;
}
.pt-100{
  padding-top: 50px;
  padding-left: 50px;
}
.cdman_image{
    height: 252px;
    width: 425px;
}
}
@media (max-width: 972px) {
  /* Rules for tablets and smaller viewports */
  .column1 {
  padding-top: 159px;
  padding-left: 46px;
  float: left;
  /* width: 50%; */
}
.body_image_upload{
  width: 100%;
  height: 2100px;
}
.pl-58{
  padding-left: 46px;
}
.pl-416{
  padding-left: 60px;
}
.pl-334{
  padding-left: 22px;
}
.pt-100{
  padding-top: 30px;
  padding-left: 50px;
}
.cdman_image{
    height: 232px;
    width: 405px;
}
}
@media (max-width: 816px){
  .mb-107{
    margin-bottom: 78px;
  }
  .mt-128{
    margin-top: 78px;
  }
  .image_upload {
    height: 695px;
}
  .upload_function{
    width: 85%;
  }
  .nodisk_image {
    height: 300px;
    width: 353px;
    margin-top: 128px;
}
  .circle_img{
  height:125px;
   width:auto;
}
.upload_img{
  width:60px; 
  height:35px; 
  margin-top: 49px;
}
.b-36{
  font-size: 26px;
}
.dot {
  height: 125px;
  width: 125px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
}
   .column1 {
  padding-top: 159px;
  padding-left: 46px;
  float: left;
  /* width: 50%; */
}
.body_image_upload{
  width: 100%;
  height: 2100px;
}
.pl-58{
  padding-left: 46px;
}
.pl-416{
  padding-left: 60px;
}
.cdman_image{
        height: 159px;
    width: 289px;
}
}
@media (max-width: 554px){
  canvas{
  height: 290px;
  width: 290px;
}
  .column1 {
    padding-top: 29px;
    padding-left: 26px;}
    #text1{
      font-size: 40px;
    }
    #text2{
      font-size: 26px;
    }#text3{
      font-size: 16px;
      padding-top: 10px;
    }
    .circle_img{
      height: 75px;
    }
    .b-36{
      font-size: 14px !important;
    }
    .dot{
      height: 75px;
      width: 75px;
    }
    .upload_img{
    width: 40px;
    height: 25px;
    margin-top:22px;
}
.image_upload{
    height: 345px;
}
.body_t {
    margin-top: 8px;
}
.scroll {
    width: 22px;
    height: 22px;
    /* border: 3px solid #707070; */
    margin-top: 12px;
}
.pl-58{
  padding-left: 16px;
}
.mt-74{
  margin-top: 14px;
}
.thirdqr{
  height: 97px;
    width: 224px;
}
.nodisk_image{
  height: 147px;
    width: 164px;
}
.cdman_image{
  height: 107px;
    width: 164px;
}
.mb-107{
  margin-bottom: 0px;
}
.pt-100{
  padding-left: 0px;
}
.pl-416{
  padding-left: 6px;
}
.button {
    width: 108px;
    height: 38px;
}
.button_content {
    font-size: 18px;
    padding-left: 26px;
    padding-top: 6px;
}
.bold_title{
  font-size: 18px;
}
.pl-20{
  padding-left: 6px;
}
.pll-20{
  padding-left: 6px;
}
 .pt-96{padding-top: 26px;}
.n-20{
  font-size: 12px;
}
.n-18{
  font-size: 8px;
} .mt-128{
  margin-top: 8px;
}.pt-86{padding-top: 26px;}
.body_image_upload {
    height: 1400px;
}
}
</style>
